import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './components/auth/LoginPage';
import ForgotPasswordContactPage from './components/auth/ForgotPasswordContactPage';
import ForgotPasswordOtpPage from './components/auth/ForgotPasswordOtpPage';
import ForgotPasswordResetPage from './components/auth/ForgotPasswordResetPage';
import SuperAgentManagementPage from './pages/SuperAgentManagementPage';
import CreateManagedAgentPage from './pages/CreateManagedAgentPage';
import ManagedAgentDetailPage from './pages/ManagedAgentDetailPage';
import ShopDetailPage from './pages/ShopDetailPage';
import DashboardPage from './pages/DashboardPage';
import AgentTransactionsPage from './pages/AgentTransactionsPage';
import AgentPaymentReturnPage from './pages/AgentPaymentReturnPage';
import SendShopPopupPage from './pages/SendShopPopupPage';
import SendBroadcastPage from './pages/SendBroadcastPage';
import ProviderFeesPage from './pages/ProviderFeesPage';
import OnlineBalanceTransactionsPage from './pages/OnlineBalanceTransactionsPage';
import FraudIndicatorsPage from './pages/FraudIndicatorsPage';
import SettingsPage from './pages/SettingsPage';
import CashTransactionsLedgerPage from './pages/cashTransactions/CashTransactionsLedgerPage';
import CashTransactionDetailPage from './pages/cashTransactions/CashTransactionDetailPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordContactPage />} />
          <Route path="/forgot-password/otp" element={<ForgotPasswordOtpPage />} />
          <Route path="/forgot-password/reset" element={<ForgotPasswordResetPage />} />
          <Route
            path="/"
            element={(
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            )}
          />
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route
            path="/agents"
            element={(
              <ProtectedRoute>
                <SuperAgentManagementPage section="agents" />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/agents/new"
            element={(
              <ProtectedRoute>
                <CreateManagedAgentPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/agents/:agentId"
            element={(
              <ProtectedRoute>
                <ManagedAgentDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/shops"
            element={(
              <ProtectedRoute>
                <SuperAgentManagementPage section="shops" />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/shops/:shopId"
            element={(
              <ProtectedRoute>
                <ShopDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/players"
            element={(
              <ProtectedRoute>
                <SuperAgentManagementPage section="players" />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/transactions"
            element={(
              <ProtectedRoute>
                <AgentTransactionsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/online-transactions"
            element={(
              <ProtectedRoute>
                <OnlineBalanceTransactionsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cash-transactions"
            element={(
              <ProtectedRoute>
                <CashTransactionsLedgerPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/cash-transactions/:id"
            element={(
              <ProtectedRoute>
                <CashTransactionDetailPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/provider-fees"
            element={(
              <ProtectedRoute>
                <ProviderFeesPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/fraud-indicators"
            element={(
              <ProtectedRoute>
                <FraudIndicatorsPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/popups/send"
            element={(
              <ProtectedRoute>
                <SendShopPopupPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/broadcasts/send"
            element={(
              <ProtectedRoute>
                <SendBroadcastPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/payment/return"
            element={(
              <ProtectedRoute>
                <AgentPaymentReturnPage />
              </ProtectedRoute>
            )}
          />
          <Route
            path="/settings"
            element={(
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            )}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
